export default __webpack_public_path__ + "static/media/home-dentist-icon-04.e4d6c006.svg";